/** @jsxImportSource @emotion/react */
import tw, { styled } from 'twin.macro';
import parse from 'html-react-parser';

import useLocalization from '../../hooks/useLocalization';

const InformationPanel = ({closePortal}) => {

  const { t, lang } = useLocalization();

  let InfoContent = require(`../../data/InfoContent_${lang}.mdx`).default;

  return (
  <InformationPanelWrapper>
    <Overlay onClick={closePortal}/>
    <InformationPanelContent>
      <PanelHeaderWrapper>
        <div css={tw`w-[300px]`}>
          <WorkshopLogo src={require('../../assets/images/logo.png')} alt="Riley"/>
        </div>
        <div css={tw`w-[calc(100% - 300px)] flex flex-col justify-between`}>
          <PanelHeaderText>
            <PanelHeaderTitle>{t('sitename')}</PanelHeaderTitle>
            {parse(t('introduction'))}
          </PanelHeaderText>
          <div css={tw`
            mt-6
            flex
            flex-wrap
            justify-between
          `}>
            <div css={tw`
              w-full
              text-right
              text-[12px]
              mb-2
            `}>Last Update: 2023-12-04</div>
            <SNSButton href="https://www.plurk.com/asahi_1156" target="_blank">
              <span className="icon-plurk"></span>
              Plurk
            </SNSButton>
            <SNSButton href="https://twitter.com/dragonlahk" target="_blank">
              <span className="icon-twitter"></span>
              Twitter
            </SNSButton>
            <SNSButton href="https://www.twitch.tv/asahi_1156" target="_blank">
              <span className="icon-twitch"></span>
              Twitch
            </SNSButton>
            <SNSButton href="https://jp.finalfantasyxiv.com/lodestone/character/27514349/" target="_blank">
              <img src={require('../../assets/images/ico_meteor.png')} alt="FFXIV"/>
              Lodestone
            </SNSButton>
            <SNSButton href="https://blog.paradeisos.net/" target="_blank">
              <span className="icon-wordpress"></span>
              Blog
            </SNSButton>
            
            
          </div>
        </div>
      </PanelHeaderWrapper>
      <InfoContentWrapper>
        <InfoContent />
      </InfoContentWrapper>
    </InformationPanelContent>

  </InformationPanelWrapper>);
}

export default InformationPanel;

const PanelHeaderWrapper = styled.div`
  ${tw`
    flex
  `}
`

const WorkshopLogo = styled.img`
  ${tw`
    w-[300px]
    h-[300px]
  `}
`

const PanelHeaderTitle = styled.h2`
  ${tw`
    text-[24px]
    font-bold
    mb-6
  `}
`

const PanelHeaderText = styled.div`
  p{
    ${tw`
      mb-6
    `}
  }
`

const SNSButton = styled.a`
  ${tw`
    inline-block
    p-2
    py-1
    bg-gray-200
    border
    border-gray-300
    border-dotted
    rounded
    font-semibold
    text-gray-700

    hover:bg-gray-300
  `}

  img, span[class^="icon-"] {
    ${tw`
      w-4
      inline-block
      align-middle
      mt-[-5px]
      mr-2
    `}
  }
  
`

const InformationPanelContent = styled.div`
  ${tw`
    bg-white
    z-20
    relative
    rounded
    shadow-2xl
    p-8
    max-w-[900px]
    mx-auto
  `}
  height: fit-content;
`

const InformationPanelWrapper = styled.div`
  ${tw`
    fixed
    z-50
    inset-0
    py-[128px]
    flex
  `}
`
const Overlay = styled.div`
  ${tw`
    absolute
    bg-black
    opacity-30
    inset-0
    z-0
  `}
`

const InfoContentWrapper = styled.div`
  ${tw`
    flex
    gap-4
    pt-6
  `}

  .column:first-of-type{
    ${tw`
      w-[30%]
    `}
  }

  .column:last-of-type{
    ${tw`
      w-[70%]
      
    `}
  }

  .column{
    ${tw`
      flex
      flex-col
    `}
  }

  h3{
    ${tw`
      text-[20px]
      font-semibold
      mb-2
    `}
  }

  .list{
    ${tw`
      rounded
      border
      border-gray-300
      p-4
      h-full
    `}
  }
`